import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { SUPPORT, igLink, mailLink } from '@shared/support/supportConfig';
import { InstagramIcon, EmailIcon } from '@shared/support/ContactIcons';
import { LEGAL_ENTITY } from '@shared/legal/entity';

/** Privacy / terms / data deletion — on every public and app page, so a visitor (or a
 *  creator whose public card we show) always sees who runs the site and how to opt out. */
export function LegalLinks({ style }: { style?: React.CSSProperties }) {
  const { t } = useTranslation('common');
  const a: React.CSSProperties = { color: 'var(--muted)', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', minHeight: 44, padding: '0 4px' };
  return (
    <nav aria-label={t('footer.legal', { defaultValue: 'Документы' })} style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap', fontSize: 12, ...style }}>
      <Link to="/privacy" style={a}>{t('footer.privacy', { defaultValue: 'Политика конфиденциальности' })}</Link>
      <Link to="/terms" style={a}>{t('footer.terms', { defaultValue: 'Условия' })}</Link>
      <Link to="/data-deletion" style={a}>{t('footer.deletion', { defaultValue: 'Удаление данных' })}</Link>
    </nav>
  );
}

/** App-wide footer: contact/social links + copyright. Mounted once per layout shell. */
export function Footer() {
  const { t } = useTranslation('common');
  const year = new Date().getFullYear();
  // 44px tall: these are tap targets on a phone, not just text.
  const link: React.CSSProperties = { color: 'var(--muted, #8890a0)', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 6, minHeight: 44, padding: '0 4px' };
  return (
    <footer
      style={{
        textAlign: 'center',
        padding: '22px 16px 28px',
        fontSize: 12,
        color: 'var(--muted, #8890a0)',
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
      }}
    >
      <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap' }}>
        <a href={mailLink()} style={link}><EmailIcon size={15} /> {SUPPORT.email}</a>
        <a href={igLink} target="_blank" rel="noreferrer" style={link}><InstagramIcon size={15} /> @{SUPPORT.instagram}</a>
      </div>
      <LegalLinks />
      <div>© {year} AdaMar · {LEGAL_ENTITY.name} · {t('footer.rights', { defaultValue: 'All rights reserved' })}</div>
    </footer>
  );
}
